import { createSlice } from "@reduxjs/toolkit";
import { getClaimDocuments } from "../../reducer/claimsDocuments/claimsDocumentsReducer";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const getClaimDocumentsSlice = createSlice({
  name: "getClaimDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClaimDocuments.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getClaimDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
      })
      .addCase(getClaimDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default getClaimDocumentsSlice.reducer;
